// src/components/dashboard/modals/PerformerDetailModal.jsx
import { X } from 'lucide-react';
// PerformerDetailModal.jsx
export default function PerformerDetailModal({ open, performer, onClose }) {
  if (!open || !performer) return null;

  const { rank, name, dept, exam, score } = performer;
  const finalRank = rank ?? 'N/A';

  const scoreColor = score >= 80 ? '#10b981' : score >= 60 ? '#f59e0b' : '#ef4444';

  return (
    <div className="pd-modal-overlay" onClick={onClose}>
      <div className="pd-modal-sm" onClick={e => e.stopPropagation()}>
        <button className="pd-modal-close" onClick={onClose}>
          <X size={20} />
        </button>

        <h2 className="pd-modal-title">
          {name}'s Performance
        </h2>

        <div className="pd-detail-grid">
          <p><strong>S.No:</strong> <span className="pd-rank">{finalRank}</span></p>
          <p><strong>Name:</strong> {name}</p>
          <p><strong>Department:</strong> {dept}</p>
          <p><strong>Assessment:</strong> {exam}</p>
          <p>
            <strong>Score:</strong>{' '}
            <span style={{ color: scoreColor, fontWeight: 'bold', fontSize: '1.2em' }}>
              {score}%
            </span>
          </p>
        </div>

        <div className="pd-modal-actions">
          <button className="pd-btn pd-btn-primary" onClick={onClose}>
            Close
          </button>
        </div>
      </div>
    </div>
  );
}